import {State} from '../types/state'

export const isEventMembershipOfferAvailable = (state: State, eventId: string): boolean => {
  const {membershipOffers} = state.membershipOffers
  return membershipOffers?.[eventId]
}
